import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { trackEvent } from "./track";
import { useI18n } from "../../i18n";

export const ImpactBlock = () => {
  const { t, lang } = useI18n();
  return (
    <section className="py-24 lg:py-32 border-t border-white/10" data-testid="impact-home-block">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="service-card p-10 lg:p-14 flex flex-col lg:flex-row lg:items-center gap-10"
        >
          <div className="flex-1">
            <p className="font-heading text-gold text-sm tracking-[0.25em] uppercase mb-6">{t("impactHome.eyebrow")}</p>
            <h2 className="font-heading font-bold tracking-tighter text-3xl sm:text-4xl lg:text-5xl mb-6">
              {t("impactHome.title")}
            </h2>
            <p className="text-[#c8d3dc] leading-relaxed max-w-2xl">{t("impactHome.text")}</p>
          </div>
          <div className="flex-shrink-0">
            <Link
              to="/impact-social"
              className="btn-gold inline-flex items-center gap-2 px-7 py-4 text-base whitespace-nowrap"
              onClick={() => trackEvent("impact_cta_click", { placement: "home", language: lang })}
              data-testid="impact-home-cta"
            >
              {t("impactHome.cta")} <ArrowRight size={18} />
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ImpactBlock;
